<template>
  <div class="sidebar-container">
    <div class="logo-container">
      <h1 v-show="!isCollapse">BlackIM</h1>
      <h1 v-show="isCollapse">B</h1>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :unique-opened="true"
        :collapse-transition="false"
        :router="true"
        mode="vertical"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(['sidebar']),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-container {
  height: 100%;
  
  .logo-container {
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #2b2f3a;
    
    h1 {
      margin: 0;
      color: #fff;
      font-size: 20px;
      font-weight: 600;
    }
  }
  
  .el-scrollbar {
    height: calc(100% - 50px);
  }
  
  .el-menu {
    border: none;
    width: 100% !important;
  }
}
</style>
